import { render, staticRenderFns } from "./GeoEmissionsImport.vue?vue&type=template&id=52449606&"
import script from "./GeoEmissionsImport.vue?vue&type=script&lang=ts&"
export * from "./GeoEmissionsImport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports